import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { LoadingStatus } from '../../../core/domain/events/state_provider';
import UniqueEntityID from '../../../core/domain/unique_entity_id';
import { Dietitian } from '../../../data/dietitian/domain/dietitian';
import { DietitianStateProvider } from '../../../data/dietitian/domain/dietitian_state_provider';
import {
  MessageTemplate,
  MessageTemplateType,
} from '../../../data/dietitian/domain/message_template/message-template';
import { MessageTemplateCommands } from '../../../data/dietitian/domain/message_template/message-template-commands';
import { AccountViewModel } from '../../dashboard/routes/questions/routes/patients-list/patients-list.facade';

@Injectable()
export class MessageEditorFacade {
  private basicContent: Map<MessageTemplateType, string> = new Map();

  constructor(
    private dietitianStateProvider: DietitianStateProvider,
    private commands: MessageTemplateCommands,
  ) {
    this.basicContent.set(
      'survey',
      'Bonjour, \n\n' +
        'Je vous invite à prendre quelques instants pour répondre à ce questionnaire avant notre prochain rendez-vous.\n',
    );
  }

  get accountStatus$(): Observable<AccountViewModel> {
    return this.dietitianStateProvider.state$.pipe(
      map((e) => {
        return <AccountViewModel>{
          isLoading: e.loading == LoadingStatus.LOADING,
          error: e.loading == LoadingStatus.ERROR ? e.message : undefined,
          dietitian: e.entity,
        };
      }),
    );
  }

  async getAllTemplate(
    dietitianId: string,
    type: MessageTemplateType,
  ): Promise<MessageTemplate[]> {
    return this.commands.getAllTemplate(dietitianId, type);
  }

  getEmptyMessageTemplate(
    type: MessageTemplateType,
    withSign: boolean,
  ): MessageTemplate {
    return MessageTemplate.create(
      { content: '', type, withSign },
      new UniqueEntityID(-1),
    );
  }

  getDefaultMessageTemplate(
    type: MessageTemplateType,
    withSign: boolean,
  ): MessageTemplate {
    return MessageTemplate.create(
      {
        content: this.basicContent.get(type) ?? 'Texte introuvable !!!',
        type,
        withSign,
      },
      new UniqueEntityID(0),
    );
  }

  getSign(dietitian: Dietitian) {
    return this.commands.getSign(dietitian);
  }
}
